<template>
  <a-card title="Create Cost Center">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Periode" prop="periode">
        <a-input v-model="form.periode" disabled></a-input>
      </a-form-model-item>
      <a-form-model-item>
        <template slot="label" class="form-between">
          <span>Upload File</span>
        </template>
        <template slot="extra">
          <div class="extra-wrapper">
            <span>Silahkan download template jika belum mempunyainya.</span>
            <a-button @click="handleDownload" type="primary" icon="download"
              >Template</a-button
            >
          </div>
        </template>
        <a-upload-dragger
          accept=".xlsx, .xls"
          name="file"
          :before-upload="beforeUpload"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p class="ant-upload-hint">Support for a single upload (*.xlsx)</p>
        </a-upload-dragger>
      </a-form-model-item>
      <a-form-model-item label="Deskripsi" prop="deskripsi">
        <a-input v-model="form.deskripsi" type="textarea"></a-input>
      </a-form-model-item>
    </a-form-model>

    <template slot="actions">
      <a-button :loading="form.loading" icon="save" @click="handleSubmit"
        >Simpan</a-button
      >
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "create-beban",
  data() {
    return {
      master: {},
      form: {
        periode: "",
        file: null,
        deskripsi: "",
        loading: false,
      },
      rules: {
        periode: [
          {
            required: true,
            message: "Periode tidak boleh kosong",
            trigger: "blur",
          },
        ],
        deskripsi: [
          {
            required: true,
            message: "Deskripsi tidak boleh kosong",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store.dispatch("getMaster").then((res) => {
        this.master = res;
        this.form.periode = res.periode;
      });
    },
    beforeUpload(file) {
      this.form.file = file;
      return false;
    },
    handleDownload() {
      window.open(process.env.VUE_APP_SERVICEURL + this.master.url_template);
    },
    handleSubmit() {
      if (this.form.file == null) {
        this.$notification.error({
          message: "Error",
          description: "Dokumen tidak boleh kosong!",
        });
      } else {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }

          this.form.loading = true;

          let postdata = new FormData();
          postdata.append("tlc", this.getAuth.username);
          postdata.append("deskripsi", this.form.deskripsi);
          postdata.append("file_upload", this.form.file);

          this.$store
            .dispatch("createBeban", { data: postdata })
            .then((res) => {
              this.displayMessage("success-save");
              this.form.loading = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.$notification.error({
                message: "Error",
                description: err.response.data.message,
              });
              this.form.loading = false;
            });
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  display: flex;
  margin-top: @margin;
  flex-direction: column;
  align-items: flex-start;
}
</style>